import {
  Center,
  Loader,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  Title
} from "@mantine/core";
import { Link, Navigate } from "react-router";
import { ROUTES } from "../../routes";
import { UserLicense } from "../../utils/enums";
import "./ProductSelectPage.scss";

interface ProductSelectPageProps {
  userLicenses: Array<UserLicense> | null;
}

function ProductSelectPage({ userLicenses }: ProductSelectPageProps) {
  if (!userLicenses) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  function checkExclusiveLicense(license: UserLicense) {
    return userLicenses?.length === 1 && userLicenses.includes(license);
  }

  if (checkExclusiveLicense(UserLicense.Analyzer)) {
    return <Navigate replace to={ROUTES.analyzer} />;
  } else if (checkExclusiveLicense(UserLicense.Manager)) {
    return <Navigate replace to={ROUTES.startPage} />;
  } else {
    return (
      <Center className="ProductSelectPage">
        <SimpleGrid cols={2} maw={1100} w="100%">
          <ProductRouterLink
            className="analyzer"
            description="Planung & Optimierung"
            header="Analyzer"
            to={ROUTES.analyzer}
          />
          <ProductRouterLink
            className="manager"
            description="Administratives Management"
            header="Manager"
            to={ROUTES.startPage}
          />
        </SimpleGrid>
      </Center>
    );
  }
}

interface ProductRouterLinkProps {
  to: string;
  header: string;
  description: string;
  className?: string;
}

function ProductRouterLink({
  to,
  header,
  description,
  className
}: ProductRouterLinkProps) {
  return (
    <Paper className={className} component={Link} p="xl" to={to}>
      <Stack align="center" gap="0">
        <Title fw={500} mb="xs">
          {header}
        </Title>
        <Text c="black" mb="md">
          {description}
        </Text>
      </Stack>
    </Paper>
  );
}

export { ProductSelectPage };
